module.exports = __webpack_public_path__ + "img/icon-delete.1e8bf198.png";